import $DB from '../../util/debounce'
export default {
  data() {
    return {
      aboutMessage: {}, //关于我们想请
      relationMessage: {}, //联系我们
      relation: {
        c_name: '',
        c_email: '',
        c_phone: '',
        c_desc: '',
      },
      location: {
        lng: '',
        lat: '',
      },
    }
  },
  created() {
    this.getAboutMessage()
    this.getRelationMessage()
  },
  methods: {
    //提交信息
    submit: $DB(function () {
      if (!this.relation.c_name) {
        this.$message.error('请输入名字')
        return
      }
      if (!this.relation.c_email.match(/^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/)) {
        this.$message.error('请输入邮箱')
        return
      }
      if (!this.relation.c_phone.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的号码')
        return
      }
      if (!this.relation.c_desc) {
        this.$message.error('请输入内容')
        return
      }
      this.$axios.post('/api/index/contactUsUp', this.relation).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
    //获取关于我们信息
    getAboutMessage() {
      this.$axios.post('/api/index/about').then((res) => {
        if (res.data.code === 0) {
          this.aboutMessage = res.data.data
        }
      })
    },
    //获取联系我们信息
    getRelationMessage() {
      this.$axios.post('/api/index/contact_us').then((res) => {
        if (res.data.code === 0) {
          let { lng, lat } = res.data.data
          this.location = { lng, lat }
          this.relationMessage = res.data.data
        }
      })
    },
  },
}
